import { ReactElement, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import StaticAutoComplete from '../base/StaticAutoComplete';
import { fetchStateList } from 'pages/NewNonEmployee/_api';
import { sortByGroup, sortByLabel } from 'pages/NewNonEmployee/_util';

/**
 * Prompt user for input: driver's license state
 * @param {string} label display text
 * @param {string} name identifying name used by Formik
 * @returns {ReactElement} autocomplete prompting for driver's license state
 */
const DriversLicenseState = props => {
	const [originalOptions, setOriginalOptions] = useState([]);
	const [sLoading, setLoading] = useState(true);

	useEffect(() => {
		let active = true;
		async function fetchApi() {
			const response = await fetchStateList();

			const processedResponse = response
				.map(r => ({
					value: r,
					label: r.stateName,
					group: r.countryName,
				}))
				.sort(sortByLabel)
				.sort(sortByGroup);
			const uniqueProcessedResponse = Array.from(
				new Set(processedResponse.map(r => r.label))
			).map(r => processedResponse.find(p => p.label === r));

			setOriginalOptions(uniqueProcessedResponse);
			setLoading(false);
		}
		if (active) {
			fetchApi();
		}

		return () => {
			active = false;
		};
	}, []);

	return sLoading ? (
		<Skeleton width='100%' />
	) : (
		<StaticAutoComplete
			originalOptions={originalOptions}
			getValue={(options, value) => {
				return options.find(
					o =>
						o.value.stateAbbreviation === value.stateAbbreviation &&
						o.value.stateName === value.stateName
				);
			}}
			isOptionEqualToValue={(option, value) =>
				option.value.countryName === value.value.countryName &&
				option.value.stateName === value.value.stateName
			}
			{...props}
		/>
	);
};

DriversLicenseState.propTypes = {
	label: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
};

export default DriversLicenseState;
